import { OnInit } from '@angular/core';
import { HomeService } from '@sc/pas-common';
var NewsComponent = /** @class */ (function () {
    function NewsComponent(_homeService) {
        this._homeService = _homeService;
        this.urlLoaded = false;
    }
    NewsComponent.prototype.ngOnInit = function () {
        this.getNewsUrl();
    };
    NewsComponent.prototype.getNewsUrl = function () {
        var _this = this;
        this._homeService.getShowNewsModal().subscribe(function (response) {
            _this.newsUrl = response.path;
            _this.urlLoaded = false;
        });
    };
    NewsComponent.prototype.onLoaded = function (event) {
        this.urlLoaded = true;
    };
    return NewsComponent;
}());
export { NewsComponent };
